import React, { Component } from 'react'
import Dialog from '@mui/material/Dialog'
import eventBus from '../../util/EventBus'
import moment from 'moment'
import { TYPE_LOCALSTORAGE } from '../../constants/Config'

export default class DialogWatingTime extends Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false,
        }
    }

    gotoBlogDetailScreen = () => {
        this.setState({ show: false })
        eventBus.dispatch('SHOW_STATUS_BOX', true)

    }


    openDialog = () => {
        this.setState({ show: true })
    }

    closeDialog = () => {
        this.setState({ show: false })
    }


    render() {
        return (
            <Dialog
                open={this.state.show}
                bodyClassName="dialog-newbie-content"
                style={{ alignItems: 'center' }}
                PaperProps={{
                    style: {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                    },
                }}
            >
                <div className="dialog-wating-time">
                    <div className='header-title-wating-time'>
                        <img src="/img/step-start-1.png" className="" style={{ marginBottom: '0px'}} />
                        <p> 今日から{moment(this.props.checkStartWorkingTimePopUp.endTime).format('MM月DD日')}までの <br></br>1ヶ月間がデビュー期間となります！</p>
                    </div>

                      <div className="dialog-first-login-area-button">
                        <button
                            className="submitUnBlock-wating-time dialog-first-login-button"
                            style={{ width: 240 }}
                            onClick={this.gotoBlogDetailScreen}
                        >
                            さっそく待機をはじめる！
                        </button>
                    </div>
                    <button
                        className="dialog-event-btn-close"
                        onClick={() => this.closeDialog()}
                        style={{ fontSize: 14, color: '#4d4b51', backgroundColor: 'white', marginBottom: 0, padding: 0 }}
                    >
                        閉じる
                    </button>
                </div>
            </Dialog>
        )
    }
}
